<script setup lang="ts">
import {onMounted, PropType, Ref, ref} from "vue";
import {ICellEditorParams} from "ag-grid-community";
import Translator from "@/utils/common/Translator.ts";
import {QInput, QPopupProxy} from "quasar";
import ClockIcon from "@/assets/widgetIcons/ClockIcon.vue";

const props = defineProps({
  params: {
    type: Object as PropType<ICellEditorParams>,
    required: true
  }
});
const qTimeInput: Ref<QInput | undefined> = ref()
const timeProxy = ref<QPopupProxy>();
let inputDate = ref(props.params.value ? props.params.formatValue(props.params.value) : '');
let selectedTime = ref(inputDate.value);

function getValue() {
  return props.params.parseValue(inputDate.value);
}

onMounted(() => {
  if (qTimeInput.value) {
    setTimeout(() => {
      qTimeInput.value?.focus();
      qTimeInput.value?.select();
      if (props.params?.eventKey?.length === 1) {
        inputDate.value = props.params?.eventKey;
      }
    })
  }
});

function onTimeSelect(value: any) {
  inputDate.value = value;
  selectedTime.value = value;
}

function onPartialUserInput(val) {
  inputDate.value = val;
}

function onClosePopupClicked(e) {
  props.params?.stopEditing();
}

function namaUpdateValue(value: string) {
  inputDate.value = value;
}

function onKeyDown(event: KeyboardEvent) {
  if (event.key !== 'F2')
    return;
  props.params?.api.stopEditing();
}

function onF4KeyClicked(e) {
  if (timeProxy.value)
    timeProxy.value.toggle(e)
}
defineExpose({getValue, namaUpdateValue});
</script>
<template>
  <q-input ref="qTimeInput" hide-bottom-space dense :model-value="inputDate" @update:model-value="onPartialUserInput"
           autocomplete="off" @keydown="onKeyDown" enterkeyhint="go"
           class="ag-custom-component-popup nama-field-input nama-customize-dense-input nama-focused-input nama-dark-popup"
           input-class="tw-bg-transparent focus:tw-ring-0 focus:tw-shadow-none focus:tw-border-none dark:tw-text-namaFontColor-dark
      dark:tw-placeholder-gray-300"
           @keydown.f4.stop="onF4KeyClicked">
    <template v-slot:append>
      <q-avatar square class="tw-cursor-pointer nama-avatar-hover">
        <ClockIcon class="tw-size-4 nama-widget-icon-hover nama-widget-icon"/>
        <q-popup-proxy ref="timeProxy" cover class="tw-bg-transparent ag-custom-component-popup" transition-show="scale" transition-hide="scale"
                       @hide="onClosePopupClicked" @keydown.f4.stop="onF4KeyClicked">
          <q-time :model-value="selectedTime" @update:model-value="onTimeSelect"
                  class="tw-text-namaBlack tw-bg-namaBackground-deep-light dark:tw-text-namaFontColor-dark dark:tw-bg-namaBackground-dim-dark">
            <div class="tw-bg-transparent row items-center justify-end">
              <q-btn @click="onClosePopupClicked" :label="Translator.translateId('close')" class="tw-text-primary-light dark:tw-text-primary-dark tw-bg-transparent" flat/>
            </div>
          </q-time>
        </q-popup-proxy>
      </q-avatar>
    </template>
  </q-input>
</template>

<style scoped>

</style>
